import {
  SpanStatusCode,
  context,
  trace,
  type Attributes,
} from "@opentelemetry/api";

/** OpenTelemetry 初始化结果。 */
export type OtelBootstrapResult = {
  enabled: boolean;
  tracerName: string;
};

const TRACER_NAME = "flower-frontend.demo";
let initialized = false;

/**
 * 初始化前端 OpenTelemetry 入口。
 */
export function initOtel(): OtelBootstrapResult {
  initialized = true;
  return {
    enabled: true,
    tracerName: TRACER_NAME,
  };
}

/**
 * 使用 Span 包裹异步任务，统一记录成功与异常状态。
 */
export async function runWithSpan<T>(
  spanName: string,
  task: () => Promise<T>,
  attributes: Attributes = {},
): Promise<T> {
  const tracer = trace.getTracer(TRACER_NAME);
  const span = tracer.startSpan(spanName);

  Object.entries(attributes).forEach(([key, value]) => {
    span.setAttribute(key, value);
  });

  try {
    const activeContext = trace.setSpan(context.active(), span);
    const result = await context.with(activeContext, task);
    span.setStatus({ code: SpanStatusCode.OK });
    return result;
  } catch (error) {
    if (error instanceof Error) {
      span.recordException(error);
    }
    span.setStatus({ code: SpanStatusCode.ERROR });
    throw error;
  } finally {
    if (initialized) {
      span.end();
    } else {
      span.end();
    }
  }
}

